// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteAccount_container__3-2bH","label":"DeleteAccount_label__1rqdb","icon":"DeleteAccount_icon__35UEI"};